jQuery(document).ready($ => {

	const is_mid_nav_page = $('#is-mid-nav-page').val();
	const current_post_type = $('#post-type').val();
	const current_post_id = $('#post-id').val();
	const stylesheet_directory = $('#stylesheet-directory').val();
	const karanga_karakia = new Audio(stylesheet_directory + '/assets/audio/karanga-karakia.m4a');

	if (is_mid_nav_page) {
		$('header').addClass('mid-nav-active');
		displayBottomNav(current_post_type);
		selectCurrentMidNav();
		selectCurrentBottomNavItem();
	}

	$('#mid-nav .nav-link').hover(e => {
		displayBottomNav(hoveredItemMenuType(e));
	})

	$('.bottom-nav').mouseleave(e => {
		displayBottomNav(current_post_type);
	})

	$('#top-nav').hover(e => {
		displayBottomNav(current_post_type);
	})

	$('#audio-box').click(e => {
		if (karanga_karakia.paused) {
			karanga_karakia.play();
		} else {
			karanga_karakia.pause();
			karanga_karakia.currentTime = 0;
		}
	})


	const hoveredItemMenuType = e => $(e.target).data('menu-type-parent');

	function selectCurrentMidNav() {
		$('#mid-nav .nav-link[data-menu-type-parent="' + current_post_type + '"]').addClass('selected');
	} 

	function displayBottomNav(menu_type) {
		$('.bottom-nav[data-menu-type="' + menu_type + '"]').removeClass('hidden');
		$('.bottom-nav:not([data-menu-type="' + menu_type + '"])').addClass('hidden');
	} 

	function selectCurrentBottomNavItem() {
		$('.bottom-nav .nav-link[data-post-id="' + current_post_id + '"]').addClass('selected');
	}

});